// extracted by mini-css-extract-plugin
export var columnList = "_dk-0";